import { Item, Task, Location } from "./CryoTypes";

type CryoButtonProps = {
  task: Item | Task | Location;
  value: boolean;
  setValue: (newKey: Item | Task | Location, newValue: boolean) => void;
  disabled?: boolean;
  hidden?: boolean;
  image?: boolean;
};

export const CryoButton = ({ task, value, setValue, disabled, hidden, image }: CryoButtonProps) => {
  if (value && disabled) {
    setValue(task, false);
  }

  if (hidden) return <></>;

  let className = "cryo-button";

  if (image) className += " image";
  if (value) className += " active";
  if (disabled) className += " disabled";

  return (
    <button
      type="button"
      onClick={() => setValue(task, !value)}
      className={className}
      disabled={disabled}
      data-tooltip-id="my-tooltip"
      data-tooltip-content={image ? task : undefined}
      data-tooltip-place="top"
    >
      {image ? <img alt={task} src={`/${task.replaceAll(" ", "")}.png`} /> : task}
    </button>
  );
};
